<template>
    <div id="balance" :style="{color: isBalancePaid ? 'var(--green)' : ''}">
        <table class="drop-shadow-sides">
            <tr>
                <td id="label">BALANCE</td>
                <td id="value">
                    <transition name="amount-drop-in" mode="out-in">
                        <div :key="amount">
                            {{ amount | toCurrency }}
                        </div>
                    </transition>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "Balance",
        computed: {
            ...mapGetters([
                "balance",
                "balanceWithTempTip",
                "balanceWithTip"
            ]),
            amount() {
                let balance;

                switch (this.$route.name) {
                    case "Tip": balance = this.balanceWithTempTip; break;
                    case "PaymentSummary": balance = this.balance; break;
                    default: balance = this.balanceWithTip;
                }

                return Math.abs(balance.toFixed(2));
            },
            isBalancePaid() {
                return this.amount === 0;
            }
        }
    }
</script>

<style scoped>
    #balance {
        max-width: var(--check-max-width);
        margin: 0 auto;
        color: var(--maroon-red);
        font-size: 20px;
        font-weight: bold;
    }

    #balance > table {
        border-top: var(--border-gray) solid 1px;
        background-color: var(--very-light-gray);
        padding: 15px 30px;
        text-align: left;
        margin: 0 10px;            
    }

    #label {
        width: 100%;
    }

    #value {
        width: 100px;
        text-align: right;
    }
</style>